exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-control {\n  font-size:9px;\n}\n.sorthead {\n  cursor: pointer;\n}\n.tableWrap {\n  background: none;\n  height: 500px;\n}\n.tableWrap thead {\n  background-color: black;\n}\n.tableWrap td, .tableWrap th {\n  font-size:.9rem;\n  line-height: .9rem;\n}\n\n.table-scroll tbody {\n  position: absolute;\n  overflow-y: scroll;\n  height: 450px;\n}\n\n.table-scroll tr {\n  width: 100%;\n  table-layout: fixed;\n  display: inline-table;\n}\n\n.table-scroll thead > tr > th {\n  border: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/inventory.component.css
// module id = 436
// module chunks = 0